var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "klm_flight_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,7 L10,6 L5.78947368,3.5 L5.78947368,0.75 C5.78947368,0.335 5.43684211,0 5,0 C4.56315789,0 4.21052632,0.335 4.21052632,0.75 L4.21052632,3.5 L0,6 L0,7 L4.21052632,5.75 L4.21052632,8.5 L3.15789474,9.25 L3.15789474,10 L5,9.5 L6.84210526,10 L6.84210526,9.25 L5.78947368,8.5 L5.78947368,5.75 L10,7 L10,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia_Flightcards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "klm_flight_icon",
    transform: "translate(5.000000, 5.000000) rotate(-270.000000) translate(-5.000000, -5.000000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.500000, -7.500000)",
    id: "KLM/Colors/KLM-Blue/500"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightType);
export default __webpack_public_path__ + "static/media/flight-type.2106995eaae27b45bb893aea553b0130.svg";
export { ForwardRef as ReactComponent };